<template>
  <div :id="id">
    <b-form-group label="Geo Whitelist">
      <div class="fake-form-control">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="geos">
            <span class="geo" v-for="g in value" :key="g">
              <b-badge variant="secondary">
                {{ g }}
              </b-badge>
            </span>
          </div>
          <div class="edit-geos-button ml-auto">
            <b-button size="" :variant="showEditor ? 'warning' : 'primary'" @click.stop="toggleEditor">
              <font-awesome-icon icon="pen"/>
                  <span>Edit</span>
            </b-button>
          </div>
        </div>
      </div>
    </b-form-group>
    <b-input-group class="geo-editor" v-if="showEditor">
      <AutoComplete :input-attrs="{class: 'form-control'}" v-model="geo" :items="filteredGeos" :get-label="getName" :component-item="template" @update-items="updateGeos" :min-len="0" @keyup.enter.native="addGeo"></AutoComplete>
      <b-button @click.stop="addGeo">Add</b-button>
    </b-input-group>
  </div>
</template>

<script>
import AutoComplete from "v-autocomplete"
import GeoTemplate from "./GeoTemplate.vue"

export default {
  name: 'Geos',

  components: {
    AutoComplete
  },

  data: function() {
    return {
      showEditor: false,
      allGeos: [],
      filteredGeos: [],
      geo: {code: "", name: ""},
      template: GeoTemplate
    };
  },

  props: {
    id: String,
    url: String,
    value: Array
  },

  methods: {
    toggleEditor() {
      this.showEditor = !this.showEditor;

      if(this.showEditor) this.getGeos();
    },

    getName(geo) {
      return geo ? geo.name : ""
    },

    codeToName(code) {
      for(var i = 0; i < this.allGeos.length; ++i) {
        if(this.allGeos[i].code == code) return this.allGeos[i].name
      }

      return code;
    },

    getGeos() {
      fetch(this.url)
      .then(function(resp) {
        return resp.json();
      })
      .then(resp => {
        this.allGeos = resp.data;
        this.filteredGeos = this.allGeos.slice();
      });
    },

    addGeo() {
      if(this.geo && this.value.indexOf(this.geo) == -1) {
        this.$emit('input', this.$_.concat(this.value, this.geo.code))
      }
    },

    removeGeo(ev) {
      let geoCode = ev.target.dataset["value"];
      this.$emit('input', this.value.filter(g => g != geoCode))
    },

    updateGeos(text) {
      if(text) {
        this.filteredGeos = this.allGeos.filter((item) => {
          return (new RegExp(text.toLowerCase())).test(item.name.toLowerCase())
        })
      }
      else {
        this.filteredGeos = this.allGeos.slice();
      }
    }
  },

  created() {
    this.getGeos()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


  .geos-input-look {
    // Mimic the global form-control style
    background: rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 2px;
    padding: 1rem; // Increased padding again
    font-size: 1rem;
    min-height: calc(1.5em + 2rem + 2px);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
        border-color: rgba(255,255,255,0.2);
    }
  }

  .geo {
    margin-left: 4px;
    margin-bottom: 2px;
    display: inline-block;
  }

  .geos {
    text-align: left;
  }

.v-autocomplete-list {
    background-color: #1B3B5B;
    width: 100%;
    text-align: left;
    border: 1px solid #80bdff;
    border-radius: 2px;
    max-height: 400px;
    overflow-y: auto;
    z-index: 2;
}

.v-autocomplete-item-active {
  background-color: #005885 !important;
}

.geo-editor {
  margin-top: 10px;
}
  
  // Make the button small and fit well
  .edit-geos-button {
      .btn {
          padding: 2px 8px;
          font-size: 0.7rem; 
      }
  }

</style>
